import { addStringBeforeFileNameExtension } from "@therms/web-js";
//#region src/modules/Files/utils/get-therms-image-thumbnail-url.ts
function getTHERMSImageThumbnailUrl(url) {
	if (!url) return "";
	if (!url.includes("s3")) return url;
	if (url.includes("therms-files")) return `${url}.thumbnail`;
	return addStringBeforeFileNameExtension(url, "_thumbnail");
}
//#endregion
export { getTHERMSImageThumbnailUrl };

//# sourceMappingURL=get-therms-image-thumbnail-url.js.map